export default "__VITE_ASSET__36fde8e5__"